module.exports = __webpack_public_path__ + "static/media/81R7aZq7SfL._SL1500_.4a4ffb51.jpg";